import type { LayoutLoad } from './$types';
import { GetZoisStore, SearchItineraryStore } from '$houdini';
import { createPartnerBoxmapsStore, isAdvertisingPartnerType } from '$lib/services/store/partnerBoxmaps';
import { augmentHoudiniStore } from '$lib/utils/augmentedHoudiniStore';
import { getItineraryResultsStore } from '$routes/(map)/routes/loadItinerary';
import { getBoxmapsOrder } from '@viamichelin/business';
import { loadZois } from './loadZois';

export const load = (async ({ parent }) => {
	const { browserPlatform } = await parent();
	const searchItineraryStore = augmentHoudiniStore(new SearchItineraryStore());
	const searchZoisStore = augmentHoudiniStore(new GetZoisStore());

	const itineraryResultsStore = getItineraryResultsStore({
		searchItineraryStore,
	});

	const boxmapsForItineraryStore = createPartnerBoxmapsStore();
	if (browserPlatform) {
		const boxmaps = getBoxmapsOrder(browserPlatform)
			.filter(isAdvertisingPartnerType)
			.map(boxmapType => ({
				type: boxmapType,
				context: 'itinerary_result_layout' as const,
			}));
		boxmapsForItineraryStore.set(boxmaps);
	}

	return {
		searchItineraryStore,
		itineraryResultsStore,
		searchZoisStore,
		zoiResultsStore: loadZois(searchZoisStore, itineraryResultsStore),
		boxmapsForItineraryStore,
	};
}) satisfies LayoutLoad;
